import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,

    meta: {
      menuLabel: "Главная",
    },
  },
  {
    path: "/auth",
    name: "auth",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AuthView.vue"),
  },
  // {
  //   path: "/registration",
  //   name: "registration",
  //   component: () =>
  //     import(/* webpackChunkName: "registration" */ "../views/RegisterView.vue"),
  // },
  {
    path: "/profile",
    name: "profile",
    // meta: {
    //   menuLabel: "Профиль",
    // },
    component: () =>
      import(/* webpackChunkName: "profile" */ "../views/ProfileView.vue"),
  },
  {
    path: "/record",
    name: "record",
    meta: {
      menuLabel: "Записаться",
    },
    component: () =>
      import(/* webpackChunkName: "record" */ "../views/record/RecordView.vue"),
    children: [
      {
        path: ":specId",
        name: "record-spec",
        component: () =>
          import(
            /* webpackChunkName: "record-spec" */ "../views/record/RecordSpecView.vue"
          ),
        children: [
          {
            path: ":docId",
            name: "record-spec-doc",
            component: () =>
              import(
                /* webpackChunkName: "record-spec-doc" */ "../views/record/RecordSpecDocView.vue"
              ),
            children: [
              {
                path: ":srvId",
                name: "record-spec-doc-srv",
                component: () =>
                  import(
                    /* webpackChunkName: "record-spec-doc-srv" */ "../views/record/RecordSpecDocSrvView.vue"
                  ),
                children: [
                  {
                    path: ":rnumbId",
                    name: "record-spec-doc-srv-confirm",
                    component: () =>
                      import(
                        /* webpackChunkName: "record-spec-doc-srv-confirm" */ "../views/record/RecordSpecDocSrvConfirmView.vue"
                      ),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/future-visits",
    name: "future-visits",
    meta: {
      menuLabel: "Запланированные посещения",
    },
    children: [
      {
        path: "/future-visits/:id",
        name: "future-visit-card",
        meta: {
          menuLabel: "Запланированное посещение",
        },
        component: () =>
          import(
            /* webpackChunkName: "future-visit-card" */ "../views/FutureVisitCardView.vue"
          ),
      },
    ],
    component: () =>
      import(
        /* webpackChunkName: "future-visits" */ "../views/FutureVisitsView.vue"
      ),
  },
  // {
  //   path: "/history-visits",
  //   name: "history-visits",
  //   meta: {
  //     menuLabel: "История посещений",
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "history-visits" */ "../views/HistoryVisitsView.vue"
  //     ),
  // },
  // {
  //   path: "/history-visits/:visitEntry",
  //   name: "history-visits-item",
  //   component: () =>
  //       import(
  //           /* webpackChunkName: "history-visits-card" */ "../views/HistoryVisitsCardView.vue"
  //           ),
  // },
  {
    path: "/labs",
    name: "labs",
    meta: {
      menuLabel: "Исследования и анализы",
    },
    component: () =>
      import(/* webpackChunkName: "labs" */ "../views/LabsView.vue"),
    children: [
      {
        path: "/labs/:id",
        name: "labs-card",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "labs-card" */ "../views/LabsCardView.vue"
          ),
      },
    ],
  },
  {
    path: "/docs",
    name: "docs",
    meta: {
      menuLabel: "Документы пациента",
    },
    component: () =>
      import(/* webpackChunkName: "docs" */ "../views/DocumentsView.vue"),
  },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes,
});

export default router;
